import { Libraries } from "@react-google-maps/api";


export const GOOGLE_MAPS_LIBRARIES: Libraries = ['places', 'drawing', 'visualization', 'geometry'];